'use client'

import * as Sentry from '@sentry/nextjs'
import { useEffect } from 'react'

// Last-resort error boundary: replaces the entire root layout, so nothing
// from the app (MantineProvider, theme CSS variables, loaded fonts) can be
// assumed to exist. Everything here is deliberately self-contained inline
// styles with hardcoded brand colors (navy #182e35, cream #faf6f2).
export default function GlobalError({
  error
}: {
  error: Error & { digest?: string }
}) {
  useEffect(() => {
    Sentry.captureException(error)
  }, [error])

  return (
    <html lang="en">
      <body style={{ margin: 0 }}>
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            minHeight: '100vh',
            backgroundColor: '#faf6f2',
            textAlign: 'center',
            padding: '0 24px'
          }}
        >
          <h1
            style={{
              fontFamily: 'Georgia, serif',
              fontSize: '3rem',
              fontWeight: 700,
              color: '#182e35',
              margin: 0
            }}
          >
            Something went wrong
          </h1>
          <p
            style={{
              fontFamily: 'system-ui, sans-serif',
              fontSize: '1.125rem',
              color: '#182e35',
              margin: '12px 0 24px'
            }}
          >
            An unexpected error occurred. Please reload the page or return home.
          </p>
          {/* Plain anchor on purpose: a full reload is the safest recovery
              after a fatal error, and Mantine/next-link may be unavailable. */}
          {/* eslint-disable-next-line @next/next/no-html-link-for-pages */}
          <a
            href="/"
            style={{
              fontFamily: 'monospace',
              textTransform: 'uppercase',
              letterSpacing: '0.03em',
              fontWeight: 600,
              fontSize: '0.875rem',
              color: '#ffffff',
              backgroundColor: '#182e35',
              padding: '10px 48px',
              borderRadius: '4px',
              textDecoration: 'none'
            }}
          >
            Back to Home
          </a>
        </div>
      </body>
    </html>
  )
}
